module.exports = "/_next/static/images/gasPipelineAndFacilityConstruction-ad01fbc6e6e3b9ba8808c2fc915c542e.webp";